(() => {
  if (window.__customerReviewsSlider) {
    window.__customerReviewsSlider.init(document);
    return;
  }

  class CustomerReviewsSlider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-customer-reviews-track]');
      this.slides = Array.from(root.querySelectorAll('[data-customer-reviews-slide]'));
      this.prevButton = root.querySelector('[data-customer-reviews-prev]');
      this.nextButton = root.querySelector('[data-customer-reviews-next]');
      this.currentIndex = 0;
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    init() {
      if (!this.track || !this.slides.length || this.root.dataset.sliderInitialized === 'true') {
        return;
      }

      this.root.dataset.sliderInitialized = 'true';
      this.shuffleSlides();

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onNextClick);
      }

      window.addEventListener('resize', this.onResize, { passive: true });
      this.update();
    }

    shuffleSlides() {
      if (!this.track || this.slides.length < 2) {
        return;
      }

      const shuffledSlides = [...this.slides];

      for (let index = shuffledSlides.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        const currentSlide = shuffledSlides[index];
        shuffledSlides[index] = shuffledSlides[randomIndex];
        shuffledSlides[randomIndex] = currentSlide;
      }

      shuffledSlides.forEach((slide) => {
        this.track.appendChild(slide);
      });

      this.slides = shuffledSlides;
      this.currentIndex = 0;
    }

    getSlidesPerView() {
      const desktop = parseInt(this.root.dataset.slidesDesktop, 10) || 4;
      const tablet = parseInt(this.root.dataset.slidesTablet, 10) || 2;
      const mobile = parseInt(this.root.dataset.slidesMobile, 10) || 1;

      if (window.innerWidth <= 767) {
        return mobile;
      }

      if (window.innerWidth <= 1024) {
        return tablet;
      }

      return desktop;
    }

    getMaxIndex() {
      return Math.max(0, this.slides.length - this.getSlidesPerView());
    }

    getSlideOffset() {
      if (!this.slides.length) {
        return 0;
      }

      const gapValue = getComputedStyle(this.track).gap || getComputedStyle(this.track).columnGap || '0';
      const gap = parseFloat(gapValue) || 0;
      const slideWidth = this.slides[0].getBoundingClientRect().width;

      return (slideWidth + gap) * this.currentIndex;
    }

    update() {
      this.currentIndex = Math.min(this.currentIndex, this.getMaxIndex());
      this.track.style.transform = `translate3d(-${this.getSlideOffset()}px, 0, 0)`;
      this.updateButtons();
    }

    updateButtons() {
      const maxIndex = this.getMaxIndex();

      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= maxIndex;
      }
    }

    onPrevClick() {
      if (this.currentIndex <= 0) {
        return;
      }

      this.currentIndex -= 1;
      this.update();
    }

    onNextClick() {
      const maxIndex = this.getMaxIndex();

      if (this.currentIndex >= maxIndex) {
        return;
      }

      this.currentIndex += 1;
      this.update();
    }

    onResize() {
      this.update();
    }
  }

  const instances = new WeakMap();

  const init = (scope = document) => {
    if (!scope || !scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll('[data-customer-reviews-slider]').forEach((root) => {
      if (instances.has(root)) {
        instances.get(root).update();
        return;
      }

      const slider = new CustomerReviewsSlider(root);
      instances.set(root, slider);
      slider.init();
    });
  };

  window.__customerReviewsSlider = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
